export enum BookingPaymentState {
  Pending = 1,
  Completed = 2
};